import { setSpreadMasksAction } from 'editor/src/store/design/slice';
import type { ThunkDispatch } from 'editor/src/store/hooks';

import { RootState } from 'editor/src/store';

import { ProductSpreadGrounds, SpreadGroundImageWODimensions, loadSpreadImages } from './setSpreadBackgroundsOperation';

const setSpreadMasksOperation =
  (data: SpreadGroundImageWODimensions[] | ProductSpreadGrounds) =>
  async (dispatch: ThunkDispatch, getState: () => RootState) => {
    const state = getState();
    // TODO remove backward compatibility block after the dashboard FE is deployed
    if (Array.isArray(data)) {
      const spreadGroundImages = await loadSpreadImages(data);
      dispatch(setSpreadMasksAction(spreadGroundImages));
    } else if (
      data.productUid === state.variants.selectedProductUid ||
      !data.productUid ||
      !state.variants.selectedProductUid
    ) {
      const spreadGroundImages = await loadSpreadImages(data.spreads);
      dispatch(setSpreadMasksAction(spreadGroundImages));
    }
  };

export default setSpreadMasksOperation;
